import * as React from 'react';
import { createRoot } from 'react-dom/client'; // <-- 1. Import aggiornato
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './theme';
import './fonts/NothingYouCouldDo-Regular.ttf';
import ReactGA from "react-ga4";
import Cookies from 'universal-cookie';
import CookieConsent from "react-cookie-consent";
import GlobalStyles from "@mui/material/GlobalStyles";

const cookies = new Cookies();
if (cookies.get('accept-cookies')) {
  ReactGA.initialize('G-3ZGZQBJTRV');
}

const handleAccept = () => {
  ReactGA.initialize('G-3ZGZQBJTRV');
};

// 2. Seleziona il container dove verrà montata l'app
const container = document.querySelector('#root');

// 3. Crea il "root" per la tua applicazione
const root = createRoot(container);

// 4. Usa root.render() per renderizzare l'app
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyles
      styles={{
        body: {
          margin: 0,
          padding: 0
        }
      }}
    />
    <App />
    <CookieConsent
      location="none"
      buttonText="Chiudi"
      cookieName="accept-cookies"
      onAccept={handleAccept}
      style={{
        position: "fixed",
        bottom: "30px",
        left: "20px",
        right: "20px",
        width: "auto",
        zIndex: 999,
        background: "rgba(0, 0, 0, 0.2)",
        alignItems: "center",
        backdropFilter: "blur(6px)",
        color: "#000",
        borderRadius: "24px",
        fontWeight: "bold",
        textShadow: "0px 0px 8px rgba(255, 255, 255, 0.9)"
      }}
      buttonStyle={{
        fontSize: "16px",
        fontWeight: "bold",
        padding: "10px 24px",
        borderRadius: "4px"
      }}
    >
      Questo sito usa i cookie per migliorare l'esperienza di navigazione.
    </CookieConsent>
  </ThemeProvider>
);